import type { AuthenticationType } from 'expo-local-authentication';
import { atom } from 'jotai';
import { isWeb } from 'smoothie';

export const deviceAuthenticationTypesAtom = atom<
    AuthenticationType[] | undefined
>(isWeb ? [] : undefined);

export const hasAttemptedAutoBiometricsLoginAtom = atom<boolean>(false);

// undefined = not started
// true = is loading
// false = is done loading
export const isLoginInProgressAtom = atom<boolean | undefined>(undefined);
// TODO - Collapse this into the isLoginInProgressAtom.
export const isOtpSubmissionInProgressAtom = atom<boolean | undefined>(
    undefined,
);
export const isUserSetupInProgressAtom = atom<boolean | undefined>(undefined);

export const isLoadingUserAfterBiometricsLoginAtom = atom<boolean | undefined>(
    undefined,
);

export const sessionTimeoutAtom = atom<number | NodeJS.Timeout | undefined>(
    undefined,
);

export const sessionTimeoutWarningAtom = atom<
    number | NodeJS.Timeout | undefined
>(undefined);
